import { useMutation } from '@tanstack/vue-query'
import { useRpQuery } from '~/composables/graphql'
import { graphql } from '~/resources/graphql'

export function useDocumentSectionAddToCartAnalyticsQuery() {
    const query = useRpQuery()

    return useMutation({
        mutationFn: async (contractId: string) => {
            const response = await query(
                graphql(/** GraphQL */ `
                    query DocumentSectionAddToCartAnalyticsQuery(
                        $contractId: ID!
                    ) {
                        node(id: $contractId) {
                            __typename
                            ... on PlanContract {
                                ...AnalyticsAddToCartResultFragment
                            }
                        }
                    }
                `),
                {
                    contractId
                }
            )

            if (
                response.node !== null &&
                response.node.__typename === 'PlanContract'
            ) {
                return response.node
            }

            return null
        }
    })
}
